import { message } from 'antd';
import { call, put, select, takeLatest } from 'redux-saga/effects';
import { checkoutReq } from 'src/services/orderService';
import { IRootState } from 'src/types/store-types';
import { SUCCESS_STATUSES } from 'src/utils/constants';

import { resetStoredCartData } from '../tours/actions';

import { orderChecking, setOrderSuccess } from './actions';
import { ORDER_CHECKOUT } from './types';

function* checkoutSaga({ payload }: any): any {
  try {
    yield put(orderChecking(true));
    const res: any = yield call(checkoutReq, payload.data);
    if (SUCCESS_STATUSES.includes(res.status)) {
      if (['completed', 'pending'].includes(res.data.paymentStatus)) {
        yield put(setOrderSuccess(true));

        let text = '';
        const lng = yield select((state: IRootState) => state.app.lng);

        if (lng === 'ru') {
          text = 'Бронирование успешно. Наша служба поддержки свяжется с вами в ближайшее время.';
        } else if (lng === 'am') {
          text = 'Ամրագրումը հաջողվեց։ Մեր աջակցման թիմը շուտով կապ կհաստատի ձեզ հետ։';
        } else {
          text = 'Successfully booked. Our support team will contact you shortly.';
        }

        message.success(text, 7);

        localStorage.removeItem('cartCount');
        localStorage.removeItem('cartToursArray');
        yield put(resetStoredCartData());
        yield put(orderChecking(false));
        if (payload.cb) {
          payload.cb();
        }
      } else {
        message.error(res.message);
        if (payload.onError) {
          payload.onError(res);
        }
        yield put(orderChecking(false));
      }
    } else {
      message.error(res.response.data.message);
      if (payload.onError) {
        payload.onError(res);
      }
      yield put(orderChecking(false));
    }
  } catch (e) {
    if (payload.onError) {
      payload.onError(e);
    }
    yield put(orderChecking(false));
  }
}

export function* watchOrders(): any {
  yield takeLatest(ORDER_CHECKOUT, checkoutSaga);
}
